import React, { useState } from "react";
import {
  Transaction_Forum,
  Transaction_Profile,
} from "../../Connections/Transaction";
import Toast from "../../Utils/Toast";
import "../../Styles/Action.css";
import { useEffect } from "react";
import LoadingSpinner from "./LoadingSpinner";
import { Link } from "react-router-dom";

const ActivitiesAction = ({
  children,
  title,
  text,
  hashtags,
  userInfo,
  reply,
  podcast,
  likeCount,
  dislikeCount,
  commentCount,
  deleteSaved,
  actionId,
  id,
  GetAgainList,
  userId,
  pageAction,
  props,
  isActive,
}) => {
  // =================================================================
  var Size = 2;
  //==================================================================
  const [comment, setComment] = useState(false);
  const [showclickButton, setShowclickButton] = useState(false);
  const [loading, setLoading] = useState(false);
  const [myIdea, setMyIdea] = useState();
  const [comentpost, setcomentpost] = useState([]);
  const [replayLoading, setReplayLoading] = useState(false);
  const [replayComment, setReplayComment] = useState(false);
  const [replayText, setReplayText] = useState();
  const [reportBox, setReportBox] = useState(false);
  const [reporText, setReporText] = useState();
  const [page, setPage] = useState(1);

  // ==================================================================

  const deleteSavedPost = (id) => {
    Transaction_Profile.DeleteSavePost(id)
      .then((res) => {
        if (res[0]) {
          GetAgainList();
          Toast("success", "پست با موفقیت حذف شد!");
        }
      })
      .catch((err) => console.log(err));
  };

  const handleLikePost = () => {
    const form = new FormData();
    form.append("Type", 1);
    form.append("ForumPostId", id);
    Transaction_Forum.AddPostLike(form)
      .then((res) => {
        if (res[0]) {
          GetAgainList();
          Toast("success", "نظرت ثبت شد!");
        }
      })
      .catch((err) => console.log(err));
  };

  const handleDisLikePost = () => {
    const form = new FormData();
    form.append("Type", 2);
    form.append("ForumPostId", id);
    Transaction_Forum.AddPostLike(form)
      .then((res) => {
        if (res[0]) {
          GetAgainList();
          Toast("success", "نظرت ثبت شد!");
        }
      })
      .catch((err) => console.log(err));
  };

  const handleSumbitIdea = () => {
    setLoading(true);
    Transaction_Forum.AddComment({ comment: myIdea, forumPostId: id })
      .then((res) => {
        if (res[0]) {
          GetAgainList();
          setMyIdea("");
          Toast("success", "نظرت ثبت شد!");
          setLoading(false);
          Transaction_Forum.Comments(undefined, id, page, Size).then((res) => {
            if (res[0]) {
              setcomentpost(res[2].data.items);
            }
          });
        } else {
          Toast("error", res[1]);
          setLoading(false);
        }
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const handleSavePost = () => {
    Transaction_Profile.AddSavePost({ forumPostId: id, campaignId: 3 })
      .then((res) => {
        if (res[0]) {
          Toast("success", "پست با موفقیت ذخیره شد!");
        }
      })
      .catch((err) => console.log(err));
  };

  const copyToClipBoard = async (text) => {
    await navigator.clipboard.writeText(text);
    Toast("success", "لینک با موفقیت برای اشتراک گذاری کپی شد!");
  };

  const handelPostReport = (text, id) => {
    const data = { text: text, forumPostId: id };
    Transaction_Forum.AddPostReport(data).then((res) => {
      if (res[0]) {
        Toast("success", "گزارش شما ثبت شد");
      } else {
        Toast("error", "مشکلی پیش آمده لطفا دوباره تلاش کنید");
      }
      setReportBox(false);
    });
  };
  // ====================================================================

  //=====================================================================
  const ShowComment = (PostID) => {
    setPage(1);
    setComment(!comment);
    if (!comment) {
      Transaction_Forum.Comments(undefined, PostID, page, Size).then((res) => {
        if (res[0]) {
          setcomentpost(res[2].data.items);
        }
      });
    }
  };

  const getCommentMore = (PostID) => {
    Transaction_Forum.Comments(undefined, PostID, page + 1, Size).then(
      (res) => {
        if (res[2]) {
          setcomentpost([...comentpost, ...res[2].data.items]);
          setPage(page + 1);
        }
      }
    );
  };

  // const handleReplayComment = () => {
  //     if (replayText) {
  //         setReplayLoading(true);

  //         Transaction_Forum.AddComment({
  //             comment: replayText,
  //             forumPostId: id,
  //         })
  //             .then((res) => {
  //                 if (res[0]) {
  //                     setReplayLoading(false);
  //                     setReplayText("");
  //                     setReplayComment(false);
  //                     Toast("success", "جوابت با موفقیت ثبت شد!");
  //                     // props.getLastPost();
  //                 } else {
  //                     Toast("error", res[1]);
  //                     setReplayLoading(false);
  //                     setReplayComment(false);
  //                     setReplayText("");
  //                 }
  //             })
  //             .catch((err) => {
  //                 console.log(err);
  //                 setReplayLoading(false);

  //             });
  //     } else {
  //         Toast("error", "اول جوابت رو بنویس.");
  //     }
  // };

  const handleLikeComment = (type, commentId) => {
    Transaction_Forum.AddPostLike({
      ForumPostId: commentId,
      Type: type,
    }).then((res) => {
      if (res[0]) {
        Toast("success", "ری‌اکشنت ثبت شد!");
        // props.getLastPost();
      }
    });
  };
  // ====================================================================

  const actionType = {
    پوستر: 5,
    "عکس نوشته": 8,
    "نقاشی و کمیک": 7,
    پادکست: 9,
    "نظرات کارشناسی": 0,
  };

  return (
    <div className="Action-wrapper" id={`${id}`}>
      {/* {replayComment ? (
                <div className="modal-wrapper">
                    <div className="NewComment_replay-comment-box">
                        <h4>جواب خودت رو بهش بنویس</h4>
                        <div className="input-group">
                            <label htmlFor="replay-input">اینجا بنویس:</label>
                            <textarea
                                id="replay-input"
                                value={replayText}
                                rows="6"
                                onChange={(e) => setReplayText(e.target.value)}
                            ></textarea>
                        </div>
                        <div className="NewComment_replay-btns-wrapper">
                            <button onClick={handleReplayComment} className="sendModalBtn">
                                {replayLoading ? <LoadingSpinner /> : "ارسال"}
                            </button>
                            <button
                                onClick={() => setReplayComment(!replayComment)}
                                className="closeModalBtn"
                            >
                                بیخیال
                            </button>
                        </div>
                    </div>
                </div>
            ) : null} */}
      {reportBox ? (
        <div className="modal-wrapper">
          <div className="report-box">
            <div className="report">
              <img src="/imgs/Book/Gozaresh.svg" />
            </div>
            <div className="report-box-inside">
              <h4>چرا فکر می‌کنی این نظر مشکل داره؟</h4>
              <div className="input-group">
                <label className="report-box-label" htmlFor="replay-input">
                  برامون بنویس:
                </label>
                <textarea
                  id="replay-input"
                  value={reporText}
                  rows="6"
                  onChange={(e) => setReporText(e.target.value)}
                ></textarea>
              </div>
              <div className="NewComment_replay-btns-wrapper">
                <button
                  onClick={() => handelPostReport(reporText, id)}
                  className="sendModalBtn"
                >
                  {replayLoading ? <LoadingSpinner /> : "ارسال"}
                </button>
                <button
                  onClick={() => setReportBox(!reportBox)}
                  className="closeModalBtn"
                >
                  بیخیال
                </button>
              </div>
            </div>
          </div>
        </div>
      ) : null}
      <div className="Action-poster">
        <div className="Action-poster-inside">
          <div className="Action-poster-inside-right">
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                height: "100%",
              }}
            >
              <div>
                {userInfo ? (
                  <div className="Action-poster-inside-right-user mobile-hidden">
                    <div className="Action-podcast-inside-right-user-center">
                      <Link
                        style={{ width: "100%" }}
                        to={`/hisstori/blog/${userId}/user/${actionId}/action/5`}
                      >
                        <p className="Action-podcast-inside-right-user-center-name">
                          {userInfo.name}
                        </p>
                      </Link>
                      <Link
                        style={{ width: "100%" }}
                        to={`/hisstori/blog/${userId}/user/${actionId}/action/5`}
                      >
                        <p className="Action-podcast-inside-right-user-center-time number-font">
                          {/* {userInfo.date} */}
                        </p>
                      </Link>
                    </div>
                    <div className="Action-podcast-inside-right-user-left">
                      <img
                        className="Action-podcast-inside-right-user-left-img"
                        src="/imgs/Profile/icon-myBook.svg"
                        onClick={() => setShowclickButton(!showclickButton)}
                      />
                      {showclickButton ? (
                        <div className="Action-inside-item2-Book-bottom-clickButton">
                          <div className="Action-inside-item2-Book-bottom-clickButton-inside">
                            <div
                              className="Action-inside-item2-Book-bottom-clickButton-inside-top"
                              onClick={() => setReportBox(!reportBox)}
                            >
                              <img
                                className="Action-inside-item2-Book-bottom-clickButton-inside-top-img"
                                src="/imgs/Profile/report.svg"
                              />
                              <p className="Action-inside-item2-Book-bottom-clickButton-inside-top-text">
                                گزارش نظر
                              </p>
                            </div>
                            {deleteSaved ? (
                              <div
                                onClick={() => deleteSavedPost(id)}
                                className="Action-inside-item2-Book-bottom-clickButton-inside-bottom"
                              >
                                <img
                                  className="Action-inside-item2-Book-bottom-clickButton-inside-top-img"
                                  src="/imgs/Profile/Save.svg"
                                />
                                <p className="Action-inside-item2-Book-bottom-clickButton-inside-top-text">
                                  حذف کردن
                                </p>
                              </div>
                            ) : (
                              <div
                                onClick={handleSavePost}
                                className="Action-inside-item2-Book-bottom-clickButton-inside-bottom"
                              >
                                <img
                                  className="Action-inside-item2-Book-bottom-clickButton-inside-top-img"
                                  src="/imgs/Profile/Save.svg"
                                />
                                <p className="Action-inside-item2-Book-bottom-clickButton-inside-top-text">
                                  ذخیره
                                </p>
                              </div>
                            )}
                            <div
                              onClick={() =>
                                copyToClipBoard(
                                  `https://ketabno.com/hisstori/blog/${userId}/user/${actionId}/action/${actionType[pageAction]}#${id}`
                                )
                              }
                              className="Action-inside-item2-Book-bottom-clickButton-inside-bottom"
                            >
                              <img
                                className="Action-inside-item2-Book-bottom-clickButton-inside-bottom-img"
                                src="/imgs/Profile/shareBook.svg"
                              />
                              <p className="Action-inside-item2-Book-bottom-clickButton-inside-bottom-text">
                                اشتراک گذاری
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                    </div>
                  </div>
                ) : null}
                <div
                  style={{ paddingTop: "30px" }}
                  className="Action-podcast-wrapper"
                >
                  {podcast ? children : null}
                </div>
                {podcast ? (
                  <div className="Action-res">
                    {/* <img
                                    className="Action-podcast-inside-left-img-svg"
                                    src="/imgs/Profile/circle-player.svg"
                                /> */}
                    <div className="Action-res-text">
                      <p className="Action-poster-inside-right-title">
                        {title}
                      </p>
                      <p className="Action-poster-inside-right-text">{text}</p>
                    </div>
                  </div>
                ) : (
                  <>
                    <p className="Action-poster-inside-right-title">{`${title}`}</p>
                    <p className="Action-poster-inside-right-text">{text}</p>
                  </>
                )}
              </div>
              <div>
                <div className="Action-poster-inside-right-hashtag">
                  {hashtags.map((hashtag) => (
                    <a
                      href="#"
                      className="Action-poster-inside-right-hashtag-book"
                    >
                      {`#${hashtag} `}
                    </a>
                  ))}
                </div>

                <div className="Action-poster-inside-right-bottom">
                  <div className="Action-poster-inside-right-bottom-right">
                    <button
                      onClick={handleLikePost}
                      className="Action-poster-inside-right-bottom-right-like"
                    >
                      <img
                        className="Action-poster-inside-right-bottom-right-like-img"
                        src="/imgs/Profile/like.svg"
                      />
                      <p className="Action-poster-inside-right-bottom-right-like-text number-font">
                        {likeCount}
                      </p>
                    </button>
                    <button
                      onClick={handleDisLikePost}
                      className="Action-poster-inside-right-bottom-right-disLike"
                    >
                      <img
                        className="Action-poster-inside-right-bottom-right-disLike-img"
                        src="/imgs/Profile/disLike.svg"
                      />
                      <p className="Action-poster-inside-right-bottom-right-disLike-text number-font">
                        {dislikeCount}
                      </p>
                    </button>
                  </div>
                  <div className="Action-poster-inside-right-bottom-left">
                    <img
                      // style={{ position: "absolute" }}
                      className="stemp-icon-activities"
                      src={
                        isActive
                          ? "/imgs/activities/accsepted-stamp.svg"
                          : "/imgs/activities/faild-stamp.svg"
                      }
                      alt=""
                    />
                    <button
                      className="Action-poster-inside-right-bottom-right-comment"
                      onClick={() => ShowComment(id)}
                    >
                      <img
                        className="Action-poster-inside-right-bottom-right-comment-img"
                        src="/imgs/Profile/comment.svg"
                      />
                      <p className="Action-poster-inside-right-bottom-right-comment-text number-font">
                        {commentCount}
                      </p>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {children ? (
            <div
              className={`Action-poster-inside-left ${
                podcast ? "d-none-1200" : ""
              }`}
            >
              {children}
            </div>
          ) : null}

          {userInfo ? (
            <div className="Action-poster-inside-right-user desktop-hidden">
              <div className="Action-podcast-inside-right-user-center">
                <Link to={`/hisstori/blog/${userId}/user/${actionId}/action/5`}>
                  <p className="Action-podcast-inside-right-user-center-name">
                    {userInfo.name}
                  </p>
                </Link>
                <Link to={`/hisstori/blog/${userId}/user/${actionId}/action/5`}>
                  <p className="Action-podcast-inside-right-user-center-time number-font">
                    {userInfo.datel}
                  </p>
                </Link>
              </div>
              <div className="Action-podcast-inside-right-user-left">
                <img
                  style={{ position: "absolute", top: "3.5px" }}
                  src="/imgs/Profile/icon-myBook.svg"
                  onClick={() => setShowclickButton(!showclickButton)}
                />
                {showclickButton ? (
                  <div className="Action-inside-item2-Book-bottom-clickButton">
                    <div className="Action-inside-item2-Book-bottom-clickButton-inside">
                      <div
                        onClick={() => setReportBox(!reportBox)}
                        className="Action-inside-item2-Book-bottom-clickButton-inside-top"
                      >
                        <img
                          className="Action-inside-item2-Book-bottom-clickButton-inside-top-img"
                          src="/imgs/Profile/report.svg"
                        />
                        <p className="Action-inside-item2-Book-bottom-clickButton-inside-top-text">
                          گزارش نظر
                        </p>
                      </div>
                      {deleteSaved ? (
                        <div
                          onClick={() => deleteSavedPost(id)}
                          className="Action-inside-item2-Book-bottom-clickButton-inside-bottom"
                        >
                          <img
                            className="Action-inside-item2-Book-bottom-clickButton-inside-top-img"
                            src="/imgs/Profile/Save.svg"
                          />
                          <p className="Action-inside-item2-Book-bottom-clickButton-inside-top-text">
                            حذف کردن
                          </p>
                        </div>
                      ) : (
                        <div
                          onClick={handleSavePost}
                          className="Action-inside-item2-Book-bottom-clickButton-inside-bottom"
                        >
                          <img
                            className="Action-inside-item2-Book-bottom-clickButton-inside-top-img"
                            src="/imgs/Profile/Save.svg"
                          />
                          <p className="Action-inside-item2-Book-bottom-clickButton-inside-top-text">
                            ذخیره
                          </p>
                        </div>
                      )}
                      <div
                        onClick={() =>
                          copyToClipBoard(
                            `https://ketabno.com/hisstori/blog/${userId}/user/${actionId}/action/${actionType[pageAction]}#${id}`
                          )
                        }
                        className="Action-inside-item2-Book-bottom-clickButton-inside-bottom"
                      >
                        <img
                          className="Action-inside-item2-Book-bottom-clickButton-inside-bottom-img"
                          src="/imgs/Profile/shareBook.svg"
                        />
                        <p className="Action-inside-item2-Book-bottom-clickButton-inside-bottom-text">
                          اشتراک گذاری
                        </p>
                      </div>
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          ) : null}
        </div>
        {comment ? (
          <div className="Action-poster-comment">
            <div className="Action-poster-comment-header-container">
              <div className="Action-poster-comment-header">
                نظرتو برامون بنویس:
              </div>
            </div>
            <div className="Action-poster-comment-header-container">
              <div className="Action-right-comment-style">
                <div className="Action-poster-comment-header-container-area">
                  <textarea
                    placeholder="اینجا نظرتو بنویس"
                    value={myIdea}
                    onChange={(e) => setMyIdea(e.target.value)}
                    className="Action-poster-comment-textarea"
                  ></textarea>
                  <button
                    onClick={handleSumbitIdea}
                    className="Action-poster-comment-header-container-button"
                  >
                    {loading ? <LoadingSpinner /> : "ثبت نظر"}
                  </button>
                </div>
              </div>

              <div className="Action-comments-comment">
                {comentpost.map((item) => (
                  <div className="Action-poster-post-container" key={item.id}>
                    <div className="Action-poster-top-container">
                      <img
                        className="Action-poster-top-container-img"
                        src={
                          !item.avatar
                            ? "/imgs/Profile/comment.svg"
                            : item.avatar
                        }
                        style={{
                          borderRadius: "50%",
                          width: "30px",
                          height: "30px",
                        }}
                      />
                      <div>
                        <span className="Action-poster-post-name">
                          {item.user}
                        </span>
                        {/* <span className="Action-poster-post-date">
                                                    1401/06/04 | 14:45
                                                </span> */}
                      </div>
                      {/* <div className="Action-poster-post-dots">
                        <img src="/imgs/Profile/icon-myBook.svg" />
                      </div> */}
                    </div>
                    <div className="Action-poster-post-text">
                      <span>{item.comment}</span>
                    </div>
                    <div className="Action-poster-post-like">
                      {/* <div className="Action-poster-post-reply-container like-disLike">
                        <button
                          className="Action-poster-inside-right-bottom-right-like"
                          onClick={() => handleLikeComment(1, item.id)}
                        >
                          <img
                            className="Action-poster-inside-right-bottom-right-like-img"
                            src="/imgs/Profile/like.svg"
                          />
                          <p className="Action-poster-inside-right-bottom-right-like-text number-font">
                            0
                          </p>
                        </button>
                        <button
                          className="Action-poster-inside-right-bottom-right-disLike"
                          onClick={() => handleLikeComment(2, item.id)}
                        >
                          <img
                            className="Action-poster-inside-right-bottom-right-disLike-img"
                            src="/imgs/Profile/disLike.svg"
                          />
                          <p className="Action-poster-inside-right-bottom-right-disLike-text number-font">
                            0
                          </p>
                        </button>
                      </div> */}
                      {/* <div className="Action-poster-post-reply-container rep"
                                                    onClick={() => setReplayComment(!replayComment)}>
                                                    <button className="Action-poster-post-reply">
                                                        <p className="Action-poster-inside-right-bottom-right-disLike-text number-font">
                                                            بهش جواب بده
                                                        </p>
                                                        <img
                                                            className="Action-poster-inside-right-bottom-right-disLike-img"
                                                            src="/imgs/Blog/reply.svg"
                                                        />
                                                    </button>
                                                </div> */}
                    </div>
                  </div>
                ))}
                {commentCount > 2 && commentCount !== comentpost.length && (
                  <div
                    className="BookAction-button"
                    onClick={() => getCommentMore(id)}
                  >
                    <button className="BookAction-button-text">
                      موارد بیشتر
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        ) : null}
        {reply ? (
          <div className="Action-poster-comment">
            <div className="Action-poster-comment-header-container">
              <div className="Action-poster-comment-header">
                نظرتو برامون بنویس:
              </div>
            </div>
            <div className="Action-poster-comment-header-container">
              <div className="Action-poster-comment-header-container-area">
                <textarea
                  placeholder="اینجا نظرتو بنویس"
                  value={myIdea}
                  onChange={(e) => setMyIdea(e.target.value)}
                  className="Action-poster-comment-textarea"
                ></textarea>
                <button
                  onClick={handleSumbitIdea}
                  className="Action-poster-comment-header-container-button"
                >
                  {loading ? <LoadingSpinner /> : "ثبت نظر"}
                </button>
              </div>

              <div className="Action-poster-post-container">
                <div className="Action-poster-top-container">
                  <img
                    src="/imgs/Profile/comment.svg"
                    className="Action-poster-top-container-img"
                  />
                  <div>
                    <span className="Action-poster-post-name">
                      لیندا کیانمهر
                    </span>
                    <span className="Action-poster-post-date">
                      1401/06/04 | 14:45
                    </span>
                  </div>
                  <div className="Action-poster-post-dots">
                    <img src="/imgs/Profile/icon-myBook.svg" />
                  </div>
                </div>
                <div className="Action-poster-post-text">
                  <span>
                    کتاب خوبی بود کتاب خوبی بود کتاب خوبی بود کتاب خوبی بود کتاب
                    خوبی بود کتاب خوبی بود کتاب خوبی بود
                  </span>
                </div>
                <div className="Action-poster-post-like">
                  <div className="Action-poster-post-reply-container">
                    <button className="Action-poster-inside-right-bottom-right-like">
                      <img
                        className="Action-poster-inside-right-bottom-right-like-img"
                        src="/imgs/Profile/like.svg"
                      />
                      <p className="Action-poster-inside-right-bottom-right-like-text number-font">
                        {likeCount}
                      </p>
                    </button>
                    <button className="Action-poster-inside-right-bottom-right-disLike">
                      <img
                        className="Action-poster-inside-right-bottom-right-disLike-img"
                        src="/imgs/Profile/disLike.svg"
                      />
                      <p className="Action-poster-inside-right-bottom-right-disLike-text number-font">
                        {dislikeCount}
                      </p>
                    </button>
                  </div>
                  <div className="Action-poster-post-reply-container">
                    <button
                      className="Action-poster-post-reply"
                      onClick={() => setReplayComment(!replayComment)}
                    >
                      <p className="Action-poster-inside-right-bottom-right-disLike-text number-font">
                        بهش جواب بده
                      </p>
                      <img
                        className="Action-poster-inside-right-bottom-right-disLike-img"
                        src="/imgs/Blog/reply.svg"
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
};

ActivitiesAction.defaultProps = {
  userInfo: false,
  hashtags: [],
  reply: false,
  podcast: false,
  deleteSaved: false,
  id: "",
  GetAgainList: () => {},
};

export default ActivitiesAction;
